import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faSave, 
    faTimes, 
    faSearch, 
    faFilter, 
    faCheck, 
    faCheckCircle,
    faTimesCircle,
    faFileInvoice,
    faNotesMedical,
    faSync,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faChevronUp,
    faEye,
    faClipboardCheck,
    faExclamationCircle,
    faClose,
    faExclamationTriangle,
    faPrint
} from '@fortawesome/free-solid-svg-icons';
import { DefaultLayout } from '../../layout/theme-customizer';
import Ordenes from '../ordenes/Index';
import OrdenesDetalle from './index_detalle';

const id = window.location.pathname.split('/').pop()
const defaultLayout = Object.keys(DefaultLayout);
const layout = id ? id : defaultLayout

class FacturarArchivo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModalOrden: false,
            ordenSeleccionada: null,
            showModalDetalleOrden: false,
            ordenDetalleSeleccionada: null,
            busqueda: '',
            eps: '',
            regimen: '',
            estado: '',
            fecha_desde: '',
            fecha_hasta: '',
            revisado: '',
            
            archivos: [],
            total: 0,
            pagina_actual: 1,
            por_pagina: 50,
            ultima_pagina: 1,
            cargando: false,
            
            expandedRows: [], // para controlar qué archivos están expandidos
            
            soloSeleccionadas: false,
            ordenesSeleccionadas: this.cargarSeleccionadasStorage(),
            showModalRevision: false,
            ordenActual: null,
            notaRevision: '',
            epsSeleccionada: null,
            
            showModalFacturacion: false,
            epsFacturacion: '',
            regimenFacturacion: '',
            planFacturacion: '',
            modalidadFacturacion: '',
            facturando: false,
            
            empresas: [],
            regimenes: [],
            planes: [],
            modalidades: [],
            
            warningMessage: '',
            errores: [],
            
            showModalValidacionOrdenes: false,
            ordenesValidacion: [],
            filtroSoloErroresValidacion: false,
            guardandoValidacion: false
        };
    }

    // Alertas
    mostrarAlerta = (icono, titulo, texto, timer = 2000) => {
        return Swal.fire({
            icon: icono, title: titulo, text: texto, timer: timer, timerProgressBar: true,
            showConfirmButton: true, confirmButtonText: 'Entendido',
            didOpen: () => {
                const container = document.querySelector('.swal2-container');
                if (container) container.style.zIndex = '2050';
            }
        });
    };

    mostrarConfirmacion = async (titulo, texto, icono = 'warning') => {
        return await Swal.fire({
            title: titulo, text: texto, icon: icono, showCancelButton: true,
            confirmButtonColor: '#d33', cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, continuar', cancelButtonText: 'Cancelar',
            reverseButtons: true,
            didOpen: () => {
                const container = document.querySelector('.swal2-container');
                if (container) container.style.zIndex = '2050';
            }
        });
    };

    mostrarLoading = (titulo = 'Procesando...', texto = 'Por favor espere') => {
        Swal.fire({
            title: titulo, text: texto, allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
                const container = document.querySelector('.swal2-container');
                if (container) container.style.zIndex = '2050';
            }
        });
    };
    cerrarLoading = () => Swal.close();

    // Storage
    cargarSeleccionadasStorage = () => {
        try {
            const guardadas = localStorage.getItem('ordenesSeleccionadasFacturarArchivoes');
            if (guardadas) {
                const data = JSON.parse(guardadas);
                if (data.eps && Array.isArray(data.ids)) {
                    setTimeout(() => this.setState({ epsSeleccionada: data.eps }), 0);
                    return data.ids;
                }
            }
            return [];
        } catch (error) {
            return [];
        }
    };

    guardarSeleccionadasStorage = (seleccionadas, eps) => {
        try {
            localStorage.setItem('ordenesSeleccionadasFacturarArchivoes', JSON.stringify({ ids: seleccionadas, eps: eps }));
            this.setState({ epsSeleccionada: eps });
        } catch (error) {}
    };

    componentDidMount() {
        this.cargarArchivos();
    }

    componentWillUnmount() {
        window.localStorage.removeItem("OrdenId");
    }

    cargarArchivos = async (pagina = 1) => {
        this.setState({ cargando: true, warningMessage: '' });
        try {
            const params = {
                busqueda: this.state.busqueda,
                eps: this.state.eps,
                regimen: this.state.regimen,
                estado: this.state.estado,
                fecha_desde: this.state.fecha_desde,
                fecha_hasta: this.state.fecha_hasta,
                pagina: pagina,
                page: pagina,
                por_pagina: this.state.por_pagina
            };

            if (this.state.soloSeleccionadas && this.state.ordenesSeleccionadas.length > 0) {
                params.solo_seleccionadas = 1;
                params.ordenes_seleccionadas = this.state.ordenesSeleccionadas;
            }

            if (this.state.revisado) params.revisado = this.state.revisado;
            Object.keys(params).forEach(key => {
                if (params[key] === '' || params[key] === null || params[key] === undefined) delete params[key];
            });

            const response = await authAxios.post('/ordenes/mostrar_archivos_facturar', params);
            
            if (response.data.success) {
                const nuevosArchivos = response.data.data;
                this.setState({
                    archivos: nuevosArchivos,
                    total: response.data.total,
                    pagina_actual: response.data.pagina_actual,
                    ultima_pagina: response.data.ultima_pagina,
                    empresas: response.data.empresas || [],
                    regimenes: response.data.regimenes || [],
                    planes: response.data.planes || [],
                    modalidades: response.data.modalidades || [],
                });
            }
        } catch (error) {
            this.mostrarAlerta('error', 'Error', 'No se pudieron cargar los archivos');
        } finally {
            this.setState({ cargando: false });
        }
    };

    mostrarAdvertencia = (mensaje) => {
        this.setState({ warningMessage: mensaje });
        setTimeout(() => this.setState({ warningMessage: '' }), 5000);
    };

    handleFilterChange = (e) => this.setState({ [e.target.name]: e.target.value });
    verOrdenModal = (archivo) => {
        window.localStorage.setItem("Archivo", 200);
        window.localStorage.setItem("TablaId", archivo.id);
        window.localStorage.removeItem("OrdenId");
        
        this.setState({
            showModalOrden: true,
            ordenSeleccionada: archivo
        });
    };

    cerrarModalOrden = () => {
        this.setState({
            showModalOrden: false,
            ordenSeleccionada: null
        });
        this.cargarArchivos(this.state.pagina_actual);
    };

    verDetalleOrdenModal = (archivo, ord) => {
        window.localStorage.setItem("Archivo", 200);
        window.localStorage.setItem("TablaId", archivo.id);
        window.localStorage.setItem("OrdenId", ord.id);
        
        this.setState({
            showModalDetalleOrden: true,
            ordenDetalleSeleccionada: { ...ord, archivo_obj: archivo }
        });
    };

    cerrarModalDetalleOrden = () => {
        window.localStorage.removeItem("OrdenId");
        this.setState({
            showModalDetalleOrden: false,
            ordenDetalleSeleccionada: null
        });
        this.cargarArchivos(this.state.pagina_actual);
    };

    descargarPDF = async (idOrden) => {
        try {
            Swal.fire({
                title: 'Generando Historia Clínica',
                text: 'Por favor espere...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await authAxios.get(`/imprimir_pdf_base64/${idOrden}`);

            if (response.data.status) {
                const pdfWindow = window.open('', '_blank');
                if (pdfWindow) {
                    pdfWindow.document.write(`
                        <html>
                            <head>
                                <title>Historia Clínica #${idOrden}</title>
                                <style>
                                    body { 
                                        margin: 0; 
                                        padding: 0; 
                                        overflow: hidden; 
                                    }
                                    iframe { 
                                        width: 100%; 
                                        height: 100vh; 
                                        border: none; 
                                    }
                                </style>
                            </head>
                            <body>
                                <iframe 
                                    src="data:application/pdf;base64,${response.data.data}" 
                                    title="Historia Clínica #${idOrden}"
                                ></iframe>
                            </body>
                        </html>
                    `);
                }

                Swal.close();
                this.mostrarAlerta('success', 'PDF generado', 'La historia clínica se abrirá en una nueva ventana');
                return true;
            } else {
                Swal.close();
                this.mostrarAlerta('error', 'Error', response.data.message || 'No se pudo generar el PDF');
                return false;
            }

        } catch (error) {
            console.error('Error generando PDF:', error);
            Swal.close();

            try {
                Swal.fire({
                    title: 'Intentando método alternativo...',
                    text: 'Por favor espere',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                const directResponse = await authAxios.get(`/imprimir_pdf/${idOrden}`, {
                    responseType: 'blob'
                });

                const url = window.URL.createObjectURL(new Blob([directResponse.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `historia_clinica_${idOrden}_${Date.now()}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();

                Swal.close();
                this.mostrarAlerta('success', 'Descarga iniciada', 'La historia clínica se está descargando');
                return true;
            } catch (fallbackError) {
                console.error('Error en fallback:', fallbackError);
                Swal.close();
                this.mostrarAlerta('error', 'Error', 'No se pudo generar la historia clínica');
                return false;
            }
        }
    };

    imprimirArchivoMasivo = async (idArchivo) => {
        try {
            Swal.fire({
                title: 'Generando Impresión Masiva',
                text: 'Por favor espere mientras se recopilan y generan las órdenes...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await authAxios.get(`/imprimir_masivo_base64/${idArchivo}`);

            if (response.data.status && response.data.data) {
                const pdfWindow = window.open('', '_blank');
                if (pdfWindow) {
                    pdfWindow.document.write(`
                        <html>
                            <head>
                                <title>Órdenes Archivo #${idArchivo}</title>
                                <style>
                                    body { margin: 0; padding: 0; overflow: hidden; }
                                    iframe { width: 100%; height: 100vh; border: none; }
                                </style>
                            </head>
                            <body>
                                <iframe 
                                    src="data:application/pdf;base64,${response.data.data}" 
                                    title="Órdenes Archivo #${idArchivo}"
                                ></iframe>
                            </body>
                        </html>
                    `);
                } else {
                    const link = document.createElement('a');
                    link.href = `data:application/pdf;base64,${response.data.data}`;
                    link.download = response.data.filename || `archivo_${idArchivo}_ordenes.pdf`;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }

                Swal.close();
                this.mostrarAlerta('success', 'PDF Masivo Generado', 'El documento se abrirá en una nueva pestaña.');
            } else {
                Swal.close();
                this.mostrarAlerta('error', 'Error', response.data.message || 'No se pudo generar el PDF');
            }
        } catch (error) {
            console.error('Error generando PDF masivo:', error);
            Swal.close();
            let msg = 'Error al comunicarse con el servidor';
            if (error.response && error.response.data && error.response.data.message) {
                msg = error.response.data.message;
            }
            this.mostrarAlerta('error', 'Error al imprimir', msg);
        }
    };

    limpiarFiltros = () => this.setState({ 
        busqueda: '', eps: '', regimen: '', estado: '', fecha_desde: '', fecha_hasta: '', revisado: '', soloSeleccionadas: false 
    }, () => this.cargarArchivos(1));

    buscar = () => this.cargarArchivos(1);

    cambiarPagina = (nuevaPagina) => {
        if (nuevaPagina >= 1 && nuevaPagina <= this.state.ultima_pagina && nuevaPagina !== this.state.pagina_actual) {
            this.cargarArchivos(nuevaPagina);
        }
    };

    toggleFiltroSeleccionadas = () => {
        if (!this.state.soloSeleccionadas && this.state.ordenesSeleccionadas.length === 0) {
            this.mostrarAdvertencia('No hay órdenes seleccionadas para filtrar');
            return;
        }
        const nuevoSolo = !this.state.soloSeleccionadas;
        this.setState(
            { soloSeleccionadas: nuevoSolo, pagina_actual: 1 },
            () => this.cargarArchivos(1)
        );
    };

    renderPaginacion = (posicion = 'top') => {
        const { cargando, archivos, pagina_actual, ultima_pagina, total, soloSeleccionadas, ordenesSeleccionadas } = this.state;
        if (cargando) return null;
        if ((!archivos || archivos.length === 0) && !soloSeleccionadas) return null;

        const cantAMostrar = soloSeleccionadas
            ? (archivos || []).filter(archivo => (archivo.ordenes_internas || []).some(ord => ordenesSeleccionadas.includes(ord.id))).length
            : (archivos ? archivos.length : 0);

        return (
            <div className={`d-flex flex-wrap justify-content-between align-items-center ${posicion === 'top' ? 'mb-3 pb-2 border-bottom' : 'mt-3 pt-2 border-top'}`}>
                <div className="d-flex align-items-center gap-2 mb-2 mb-md-0">
                    <span className="text-muted small">
                        Mostrando <strong className="text-dark">{cantAMostrar}</strong> de <strong className="text-dark">{total}</strong> registros
                    </span>
                    {soloSeleccionadas && (
                        <span className="badge bg-warning text-dark ms-2">
                            Filtrando seleccionadas ({ordenesSeleccionadas.length})
                        </span>
                    )}
                </div>
                <div className="d-flex align-items-center gap-1">
                    <button 
                        type="button"
                        className="btn btn-sm btn-outline-primary" 
                        onClick={() => this.cambiarPagina(1)} 
                        disabled={pagina_actual <= 1}
                        title="Primera página"
                    >
                        &laquo; Primero
                    </button>
                    <button 
                        type="button"
                        className="btn btn-sm btn-outline-primary" 
                        onClick={() => this.cambiarPagina(pagina_actual - 1)} 
                        disabled={pagina_actual <= 1}
                        title="Página anterior"
                    >
                        <FontAwesomeIcon icon={faChevronLeft} /> Anterior
                    </button>
                    <span className="mx-2 fw-bold text-dark small">
                        Página {pagina_actual} de {ultima_pagina || 1}
                    </span>
                    <button 
                        type="button"
                        className="btn btn-sm btn-outline-primary" 
                        onClick={() => this.cambiarPagina(pagina_actual + 1)} 
                        disabled={pagina_actual >= ultima_pagina}
                        title="Página siguiente"
                    >
                        Siguiente <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                    <button 
                        type="button"
                        className="btn btn-sm btn-outline-primary" 
                        onClick={() => this.cambiarPagina(ultima_pagina)} 
                        disabled={pagina_actual >= ultima_pagina}
                        title="Última página"
                    >
                        Último &raquo;
                    </button>
                </div>
            </div>
        );
    };

    renderBarraAccionesFacturar = () => {
        const { epsSeleccionada, soloSeleccionadas, ordenesSeleccionadas } = this.state;
        return (
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 p-2 bg-light rounded border">
                <div className="d-flex align-items-center gap-2 mb-2 mb-md-0">
                    <span className="fw-bold text-dark small">
                        <FontAwesomeIcon icon={faFileInvoice} className="me-1 text-primary" />
                        Acciones de Facturación:
                    </span>
                    {epsSeleccionada && (
                        <span className="badge bg-info text-white">
                            EPS: {this.getNombreEmpresa(epsSeleccionada)}
                        </span>
                    )}
                </div>
                <div className="d-flex align-items-center gap-2">
                    <button 
                        type="button" 
                        className={`btn btn-sm ${soloSeleccionadas ? 'btn-primary' : 'btn-outline-primary'}`} 
                        onClick={this.toggleFiltroSeleccionadas}
                        title={soloSeleccionadas ? "Ver todos los registros" : "Ver solo las órdenes seleccionadas"}
                    >
                        <FontAwesomeIcon icon={faFilter} className="me-1" />
                        {soloSeleccionadas ? 'Ver todos los archivos' : `Ver seleccionadas (${ordenesSeleccionadas.length})`}
                    </button>
                    {ordenesSeleccionadas.length > 0 && (
                        <button className="btn btn-warning btn-sm text-dark" onClick={this.limpiarSeleccion} title="Limpiar todas las órdenes seleccionadas">
                            <FontAwesomeIcon icon={faTimes} className="me-1" /> Limpiar ({ordenesSeleccionadas.length})
                        </button>
                    )}
                    <button 
                        className="btn btn-success btn-sm text-white fw-bold shadow-sm" 
                        onClick={this.abrirModalFacturacion} 
                        disabled={ordenesSeleccionadas.length === 0}
                        title={ordenesSeleccionadas.length === 0 ? "Seleccione al menos una orden para facturar" : `Facturar ${ordenesSeleccionadas.length} órdenes seleccionadas`}
                    >
                        <FontAwesomeIcon icon={faFileInvoice} className="me-1" /> Facturar ({ordenesSeleccionadas.length})
                    </button>
                </div>
            </div>
        );
    };

    getNombreEmpresa = (id) => {
        const empresa = this.state.empresas.find(e => e.id == id);
        return empresa ? empresa.nombre : `EPS ${id}`;
    };

    getNombreRegimen = (archivo) => {
        if (!archivo) return '';
        if (archivo.regimen_nombre) return archivo.regimen_nombre;
        const cod = archivo.regimen;
        if (!cod) return '';
        const found = this.state.regimenes.find(r => String(r.codigo) === String(cod) || String(r.id) === String(cod));
        return found ? found.nombre : `Régimen ${cod}`;
    };

    toggleRow = (id) => {
        this.setState(prevState => {
            const expandedRows = prevState.expandedRows.includes(id) 
                ? prevState.expandedRows.filter(rowId => rowId !== id)
                : [...prevState.expandedRows, id];
            return { expandedRows };
        });
    };

    puedeSeleccionarOrden = (eps_archivo) => {
        const { ordenesSeleccionadas, epsSeleccionada } = this.state;
        if (ordenesSeleccionadas.length === 0) return true;
        return eps_archivo === epsSeleccionada;
    };

    toggleSeleccionOrden = (orden_id, eps_archivo, porcentaje) => {
        if (porcentaje < 100) {
            this.mostrarAdvertencia('Solo se pueden seleccionar órdenes completadas al 100%');
            return;
        }

        this.setState(prevState => {
            let seleccionadas;
            let nuevaEpsSeleccionada = prevState.epsSeleccionada;
            let nuevoSolo = prevState.soloSeleccionadas;

            if (!prevState.ordenesSeleccionadas.includes(orden_id)) {
                if (!this.puedeSeleccionarOrden(eps_archivo)) {
                    this.mostrarAdvertencia(`Solo puede seleccionar órdenes de la EPS ${this.getNombreEmpresa(prevState.epsSeleccionada)}`);
                    return prevState;
                }
                seleccionadas = [...prevState.ordenesSeleccionadas, orden_id];
                if (prevState.ordenesSeleccionadas.length === 0) {
                    nuevaEpsSeleccionada = eps_archivo;
                }
            } else {
                seleccionadas = prevState.ordenesSeleccionadas.filter(id => id !== orden_id);
                if (seleccionadas.length === 0) {
                    nuevaEpsSeleccionada = null;
                    nuevoSolo = false;
                }
            }
            this.guardarSeleccionadasStorage(seleccionadas, nuevaEpsSeleccionada);
            return { 
                ordenesSeleccionadas: seleccionadas, 
                epsSeleccionada: nuevaEpsSeleccionada,
                soloSeleccionadas: nuevoSolo
            };
        }, () => {
            if (this.state.soloSeleccionadas === false && this.state.ordenesSeleccionadas.length === 0) {
                this.cargarArchivos(1);
            }
        });
    };

    limpiarSeleccion = () => {
        this.setState({ ordenesSeleccionadas: [], epsSeleccionada: null, soloSeleccionadas: false }, () => {
            this.cargarArchivos(1);
        });
        localStorage.removeItem('ordenesSeleccionadasFacturarArchivoes');
    };

    abrirModalFacturacion = async () => {
        const { ordenesSeleccionadas } = this.state;
        if (!ordenesSeleccionadas || ordenesSeleccionadas.length === 0) {
            this.mostrarAlerta('warning', 'Atención', 'Debe seleccionar al menos una orden para facturar');
            return;
        }

        this.mostrarLoading('Verificando órdenes...', 'Validando campos requeridos para facturación');

        try {
            const response = await authAxios.post('/ordenes/verificar_ordenes_facturar', {
                ids: ordenesSeleccionadas
            });

            this.cerrarLoading();

            if (response.data && response.data.status) {
                const todas = response.data.todas_las_ordenes || [];
                const hayErrores = !!response.data.hay_errores;

                this.setState({
                    ordenesValidacion: todas,
                    filtroSoloErroresValidacion: hayErrores,
                    showModalValidacionOrdenes: true
                });
            } else {
                this.mostrarAlerta('error', 'Error al verificar', response.data.message || 'No se pudieron verificar las órdenes');
            }
        } catch (error) {
            this.cerrarLoading();
            let msg = 'No se pudo verificar el estado de las órdenes';
            if (error.response && error.response.data && error.response.data.message) {
                msg = error.response.data.message;
            }
            this.mostrarAlerta('error', 'Error', msg);
        }
    };

    cerrarModalValidacion = () => {
        if (this.state.guardandoValidacion) return;
        this.setState({
            showModalValidacionOrdenes: false,
            ordenesValidacion: []
        });
    };

    handleValidacionCampoChange = (id, campo, valor) => {
        this.setState(prevState => {
            const ordenesValidacion = prevState.ordenesValidacion.map(ord => {
                if (ord.id === id) {
                    const updated = { ...ord, [campo]: valor };
                    const errs = [];
                    const aut = (updated.orden_externa || '').toString().trim();
                    const val = parseFloat(updated.valor_atencion);

                    if (!aut) {
                        errs.push('Falta autorización');
                    }
                    if (isNaN(val) || val <= 0) {
                        errs.push('Falta precio');
                    }

                    updated.tiene_error = errs.length > 0;
                    updated.errores = errs;
                    return updated;
                }
                return ord;
            });
            return { ordenesValidacion };
        });
    };

    actualizarOrdenesEnArchivos = (ordenesActualizadas) => {
        const mapActualizadas = {};
        ordenesActualizadas.forEach(o => {
            mapActualizadas[o.id] = o;
        });

        this.setState(prevState => {
            const nuevosArchivos = (prevState.archivos || []).map(arch => {
                if (!arch.ordenes_internas) return arch;
                const nuevasOrdenes = arch.ordenes_internas.map(ord => {
                    if (mapActualizadas[ord.id]) {
                        const act = mapActualizadas[ord.id];
                        return {
                            ...ord,
                            orden_externa: act.orden_externa,
                            valor_atencion: act.valor_atencion,
                            valor_copago: act.valor_copago
                        };
                    }
                    return ord;
                });
                return { ...arch, ordenes_internas: nuevasOrdenes };
            });
            return { archivos: nuevosArchivos };
        });
    };

    guardarCambiosValidacion = async () => {
        const { ordenesValidacion } = this.state;

        // Validar si existen órdenes con campos requeridos vacíos
        const conErrores = (ordenesValidacion || []).filter(o => {
            const aut = (o.orden_externa || '').toString().trim();
            const val = parseFloat(o.valor_atencion);
            return !aut || isNaN(val) || val <= 0;
        });

        if (conErrores.length > 0) {
            this.mostrarAlerta(
                'error',
                'Campos incompletos',
                `No puedes generar la factura porque tienes ${conErrores.length} orden(es) con campos en vacío (Autorización y/o Precio). Por favor corríjalos antes de continuar.`
            );
            return;
        }

        this.setState({ guardandoValidacion: true });
        this.mostrarLoading('Guardando cambios...', 'Actualizando órdenes para facturación');

        try {
            const payload = ordenesValidacion.map(o => ({
                id: o.id,
                orden_externa: (o.orden_externa || '').toString().trim(),
                valor_atencion: parseFloat(o.valor_atencion) || 0,
                valor_copago: parseFloat(o.valor_copago) || 0
            }));

            const response = await authAxios.post('/ordenes/actualizar_ordenes_facturacion', {
                ordenes: payload
            });

            this.cerrarLoading();

            if (response.data && response.data.status) {
                // Actualizar localmente en archivos
                this.actualizarOrdenesEnArchivos(payload);

                // Cerrar modal de validación y abrir modal de facturación (datos EPS/Régimen)
                this.setState({
                    showModalValidacionOrdenes: false,
                    guardandoValidacion: false,
                    showModalFacturacion: true,
                    epsFacturacion: this.state.epsSeleccionada || this.state.eps || '',
                    regimenFacturacion: this.state.regimen === 'contributivos' ? '' : (this.state.regimen || ''),
                    planFacturacion: '',
                    modalidadFacturacion: ''
                });
            } else {
                this.mostrarAlerta('error', 'Error al actualizar', response.data.message || 'No se pudieron actualizar las órdenes');
                this.setState({ guardandoValidacion: false });
            }
        } catch (error) {
            this.cerrarLoading();
            let msg = 'Error al comunicarse con el servidor al actualizar órdenes';
            if (error.response && error.response.data && error.response.data.message) {
                msg = error.response.data.message;
            }
            this.mostrarAlerta('error', 'Error', msg);
            this.setState({ guardandoValidacion: false });
        }
    };

    cerrarModalFacturacion = () => this.setState({ showModalFacturacion: false, facturando: false });

    handleEpsFacturacionChange = async (e) => {
        const nuevaEps = e.target.value;
        const { ordenesSeleccionadas, epsSeleccionada } = this.state;
        
        if (ordenesSeleccionadas.length > 0) {
            if (nuevaEps && epsSeleccionada && nuevaEps !== epsSeleccionada) {
                this.cerrarModalFacturacion();
                const result = await this.mostrarConfirmacion(
                    '¿Cambiar EPS?',
                    `Las órdenes seleccionadas son de ${this.getNombreEmpresa(epsSeleccionada)}. Si cambia la EPS, se limpiará la selección actual.`
                );
                if (result.isConfirmed) {
                    this.limpiarSeleccion();
                    this.setState({ showModalFacturacion: true, epsFacturacion: nuevaEps });
                } else {
                    this.setState({ showModalFacturacion: true, epsFacturacion: epsSeleccionada });
                }
                return;
            }
        }
        this.setState({ epsFacturacion: nuevaEps });
    };

    revisarOrden = async (archivoId, ordenId) => {
        try {
            const response = await authAxios.post('/ordenes/revisar', { id: ordenId });
            if (response.data.success) {
                this.setState(prevState => {
                    const nuevosArchivos = prevState.archivos.map(arch => {
                        if (arch.id === archivoId) {
                            const nuevasOrdenes = arch.ordenes_internas.map(o => {
                                if (o.id === ordenId) {
                                    return { ...o, revisado: 'Si' };
                                }
                                return o;
                            });
                            return { ...arch, ordenes_internas: nuevasOrdenes };
                        }
                        return arch;
                    });
                    return { archivos: nuevosArchivos };
                });
                Swal.fire({ icon: 'success', title: 'Éxito', text: 'Orden revisada correctamente', timer: 1500, showConfirmButton: false });
            } else {
                this.mostrarAlerta('error', 'Error', response.data.message || 'No se pudo revisar la orden');
            }
        } catch (error) {
            this.mostrarAlerta('error', 'Error', 'Ocurrió un error al revisar la orden');
        }
    };

    facturarSeleccionadas = async () => {
        const { ordenesSeleccionadas, epsFacturacion, regimenFacturacion, planFacturacion, modalidadFacturacion, epsSeleccionada } = this.state;

        if (!epsFacturacion || !regimenFacturacion || !modalidadFacturacion || !planFacturacion) {
            this.mostrarAlerta('error', 'Error', 'Debe diligenciar todos los campos marcados con *');
            return;
        }

        if (ordenesSeleccionadas.length > 0 && epsFacturacion !== epsSeleccionada) {
            this.mostrarAlerta('error', 'Error', `La EPS seleccionada no coincide con la EPS de las órdenes (${this.getNombreEmpresa(epsSeleccionada)})`);
            return;
        }

        const result = await this.mostrarConfirmacion('¿Confirmar facturación?', `Va a facturar ${ordenesSeleccionadas.length} orden(es)`);
        if (!result.isConfirmed) return;
        
        this.cerrarModalFacturacion();
        this.setState({ facturando: true });
        this.mostrarLoading('Facturando...', 'Por favor espere');

        try {
            const response = await authAxios.post('/ordenes/facturar', {
                ids: ordenesSeleccionadas,
                eps: epsFacturacion,
                regimen: regimenFacturacion,
                plan_servicio: planFacturacion,
                modalidad_pago: modalidadFacturacion
            });

            this.cerrarLoading();

            if (response.data.status) {
                await this.mostrarAlerta('success', '¡Factura Generada!', `Factura #${response.data.factura_id} generada correctamente.`, 4000);
                this.limpiarSeleccion();
                await this.cargarArchivos(this.state.pagina_actual);
                this.setState({ facturando: false });
            } else {
                this.mostrarAlerta('error', 'Error', response.data.message || 'Error al facturar');
                this.setState({ facturando: false });
            }
        } catch (error) {
            this.cerrarLoading();
            let msg = 'No se pudieron facturar las órdenes';
            if (error.response && error.response.data) msg = error.response.data.message || msg;
            this.mostrarAlerta('error', 'Error', msg);
            this.setState({ facturando: false, showModalFacturacion: true });
        }
    };

    render() {
        const { 
            busqueda, eps, regimen, estado, fecha_desde, fecha_hasta, revisado,
            archivos, cargando,
            ordenesSeleccionadas, epsSeleccionada, expandedRows, soloSeleccionadas,
            showModalOrden, ordenSeleccionada,
            showModalDetalleOrden, ordenDetalleSeleccionada,
            showModalFacturacion, epsFacturacion, regimenFacturacion, planFacturacion, modalidadFacturacion, facturando,
            empresas, regimenes, planes, modalidades, warningMessage,
            showModalValidacionOrdenes, ordenesValidacion, filtroSoloErroresValidacion, guardandoValidacion
        } = this.state;

        const ordenesConErroresValidacion = (ordenesValidacion || []).filter(o => o.tiene_error);
        const totalErroresValidacion = ordenesConErroresValidacion.length;
        const listaOrdenesMostrar = filtroSoloErroresValidacion
            ? ordenesConErroresValidacion
            : (ordenesValidacion || []);

        const archivosAMostrar = soloSeleccionadas
            ? archivos.filter(archivo => (archivo.ordenes_internas || []).some(ord => ordenesSeleccionadas.includes(ord.id)))
            : archivos;

        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">
                                    <b>FACTURAR ORDENES</b>
                                </h5>
                                {epsSeleccionada && (
                                    <span className="badge bg-info text-white">EPS: {this.getNombreEmpresa(epsSeleccionada)}</span>
                                )}
                            </div>
                            
                            {warningMessage && (
                                <div className="alert alert-warning alert-dismissible fade show m-3" role="alert">
                                    <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" /> {warningMessage}
                                    <button type="button" className="btn-close" onClick={() => this.setState({ warningMessage: '' })}></button>
                                </div>
                            )}

                            <div className="card-body">
                                <div className="row mb-4">
                                    <div className="col-md-12">
                                        <div className="card bg-secondary">
                                            <div className="card-body">
                                                <h6 className="mb-3">Filtros de búsqueda</h6>
                                                <div className="row">
                                                    <div className="col-md-3 mb-2">
                                                        <label>Búsqueda general</label>
                                                        <input type="text" className="form-control form-control-sm" name="busqueda" value={busqueda} onChange={this.handleFilterChange} placeholder="Orden externa, atención, paciente..." />
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>EPS</label>
                                                        <select className="form-control form-control-sm" name="eps" value={eps} onChange={this.handleFilterChange}>
                                                            <option value="">Todas las EPS</option>
                                                            {empresas.map(emp => <option key={emp.id} value={emp.id}>{emp.nombre}</option>)}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>Régimen</label>
                                                        <select className="form-control form-control-sm" name="regimen" value={regimen} onChange={this.handleFilterChange}>
                                                            <option value="">Todos</option>
                                                            <option value="contributivos">Todos los contributivos 01,02,03</option>
                                                            {regimenes.map(reg => <option key={reg.id} value={reg.codigo}>{reg.nombre}</option>)}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>Estado</label>
                                                        <select className="form-control form-control-sm" name="estado" value={estado} onChange={this.handleFilterChange}>
                                                            <option value="">Todos</option>
                                                            <option value="completadas">Completadas (100%)</option>
                                                            <option value="no_completadas">No Completadas</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>Revisado</label>
                                                        <select className="form-control form-control-sm" name="revisado" value={revisado} onChange={this.handleFilterChange}>
                                                            <option value="">Todos</option>
                                                            <option value="Si">Sí</option>
                                                            <option value="No">No</option>
                                                            <option value="null">Sin revisar</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>Fecha Desde</label>
                                                        <input type="date" className="form-control form-control-sm" name="fecha_desde" value={fecha_desde} onChange={this.handleFilterChange} />
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>Fecha Hasta</label>
                                                        <input type="date" className="form-control form-control-sm" name="fecha_hasta" value={fecha_hasta} onChange={this.handleFilterChange} />
                                                    </div>
                                                    <div className="col-md-2 mb-2 d-flex flex-column justify-content-end">
                                                        <div className="form-check form-switch mb-1">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                id="filtroSoloSeleccionadas"
                                                                checked={soloSeleccionadas} 
                                                                onChange={this.toggleFiltroSeleccionadas} 
                                                            />
                                                            <label className="form-check-label fw-bold small text-white" htmlFor="filtroSoloSeleccionadas">
                                                                Solo seleccionadas ({ordenesSeleccionadas.length})
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mt-2">
                                                        <button className="btn btn-primary btn-sm me-2" onClick={this.buscar}><FontAwesomeIcon icon={faSearch} /> Buscar</button>
                                                        <button className="btn btn-secondary btn-sm" onClick={this.limpiarFiltros}><FontAwesomeIcon icon={faTimes} /> Limpiar</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {this.renderBarraAccionesFacturar()}

                                {this.renderPaginacion('top')}

                                <div className="table-responsive">
                                    <table className="table table-hover table-bordered table-sm">
                                        <thead className="table-primary">
                                            <tr>
                                                <th width="40"></th>
                                                <th>N. Archivo</th>
                                                <th>Paciente</th>
                                                <th>EPS</th>
                                                <th>Diagnóstico</th>
                                                <th>Fecha Inicial</th>
                                                <th>Fecha Final</th>
                                                <th>Cantidad</th>
                                                <th>% General</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cargando ? (
                                                <tr><td colSpan="10" className="text-center"><div className="spinner-border text-primary"></div></td></tr>
                                            ) : archivosAMostrar.length === 0 ? (
                                                <tr>
                                                    <td colSpan="10" className="text-center text-muted p-4">
                                                        {soloSeleccionadas 
                                                            ? 'No hay órdenes seleccionadas para mostrar en esta vista.' 
                                                            : 'No hay archivos para mostrar'}
                                                    </td>
                                                </tr>
                                            ) : (
                                                archivosAMostrar.map(archivo => {
                                                    const isExpanded = soloSeleccionadas || expandedRows.includes(archivo.id);
                                                    let ordenesInternas = (soloSeleccionadas
                                                        ? (archivo.ordenes_internas || []).filter(ord => ordenesSeleccionadas.includes(ord.id))
                                                        : (archivo.ordenes_internas || [])
                                                    ).slice().sort((a, b) => Number(a.id) - Number(b.id));

                                                    if (revisado) {
                                                        if (revisado === 'null') {
                                                            ordenesInternas = ordenesInternas.filter(ord => !ord.revisado || ord.revisado === 'null');
                                                        } else {
                                                            ordenesInternas = ordenesInternas.filter(ord => ord.revisado === revisado);
                                                        }
                                                    }
                                                    return (
                                                        <React.Fragment key={archivo.id}>
                                                            <tr>
                                                                <td className="text-center" onClick={() => this.toggleRow(archivo.id)}>
                                                                    <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} style={{cursor: 'pointer'}} />
                                                                </td>
                                                                <td>{archivo.numero_archivo}</td>
                                                                <td>
                                                                    <div>
                                                                        {archivo.nombre} {archivo.apellido} <small className="text-muted">CC: {archivo.cedula}</small>
                                                                    </div>
                                                                    {this.getNombreRegimen(archivo) && (
                                                                        <div className="mt-1">
                                                                            <span className="badge bg-light text-primary border border-primary" style={{ fontSize: '0.72rem', whiteSpace: 'normal', textAlign: 'left' }}>
                                                                                {this.getNombreRegimen(archivo)}
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                                <td><span className="badge bg-secondary">{this.getNombreEmpresa(archivo.eps)}</span></td>
                                                                <td>{archivo.diagnostico}</td>
                                                                <td>{archivo.fecha_inicial}</td>
                                                                <td>{archivo.fecha_final}</td>
                                                                <td className="text-center">{archivo.cantidad}</td>
                                                                <td>
                                                                    <div className="progress" style={{ height: '20px' }}>
                                                                        <div className={`progress-bar ${archivo.porcentaje_general >= 100 ? 'bg-success' : 'bg-warning'}`} style={{ width: `${archivo.porcentaje_general || 0}%` }}>
                                                                            {archivo.porcentaje_general || 0}%
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="btn-group btn-group-xs" role="group">
                                                                        <button className="btn btn-info btn-xs text-white" onClick={() => this.verOrdenModal(archivo)} title="Ver orden completa">
                                                                            <FontAwesomeIcon icon={faEye} />
                                                                        </button>
                                                                        <button className="btn btn-success btn-xs text-white ms-1" onClick={() => this.imprimirArchivoMasivo(archivo.id)} title="Imprimir órdenes activas del archivo">
                                                                            <FontAwesomeIcon icon={faPrint} />
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            {isExpanded && (
                                                                <tr>
                                                                    <td colSpan="10" className="p-3 bg-light">
                                                                        <table className="table table-sm table-bordered bg-white mb-0">
                                                                            <thead className="table-dark" style={{ color: 'white' }}>
                                                                                <tr style={{ color: 'white' }}>
                                                                                    <th width="40">Sel</th>
                                                                                    <th>ID</th>
                                                                                    <th>Orden Externa</th>
                                                                                    <th>Atención</th>
                                                                                    <th>Cantidad</th>
                                                                        
                                                                                    <th>%</th>
                                                                                    <th>Paquete</th>
                                                                                    <th>Profesional</th>
                                                                                    <th>Acciones</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody className="text-dark">
                                                                                {ordenesInternas.map(ord => {
                                                                                    const seleccionada = ordenesSeleccionadas.includes(ord.id);
                                                                                    const disabled = ord.porcentaje < 100 || ord.factura > 0 || ord.revisado !== 'Si';
                                                                                    return (
                                                                                        <tr key={ord.id} className={seleccionada ? 'table-primary text-dark' : 'text-dark'}>
                                                                                            <td className="text-center">
                                                                                                <input 
                                                                                                    type="checkbox" 
                                                                                                    checked={seleccionada}
                                                                                                    disabled={disabled && !seleccionada}
                                                                                                    onChange={() => this.toggleSeleccionOrden(ord.id, archivo.eps, ord.porcentaje)}
                                                                                                />
                                                                                            </td>
                                                                                            <td className="text-dark">{ord.id}</td>
                                                                                            <td className="text-dark">{ord.orden_externa}</td>
                                                                                            <td className="text-dark" title={ord.atencion ? `Código: ${ord.atencion}` : ''}>
                                                                                                <div>{ord.atencion_nombre || ord.atencion}</div>
                                                                                                {ord.atencion_nombre && ord.atencion && (
                                                                                                    <small className="text-muted d-block" style={{ fontSize: '0.75rem' }}>CUPS: {ord.atencion}</small>
                                                                                                )}
                                                                                            </td>
                                                                                            <td className="text-center text-dark">{ord.cantidad}</td>
                                                                                         
                                                                                            <td>
                                                                                                <span className={`badge ${ord.porcentaje >= 100 ? 'bg-success' : 'bg-danger'}`}>
                                                                                                    {ord.porcentaje}%
                                                                                                </span>
                                                                                            </td>
                                                                                            <td className="text-dark">{ord.paquete}</td>
                                                                                            <td className="text-dark">{ord.profesional}</td>
                                                                                            <td className="text-center">
                                                                                                <div className="d-flex justify-content-center align-items-center gap-1">
                                                                                                    {ord.porcentaje >= 100 && ord.revisado !== 'Si' && !ord.factura ? (
                                                                                                        <button 
                                                                                                            className="btn btn-danger btn-xs" 
                                                                                                            onClick={() => this.revisarOrden(archivo.id, ord.id)} 
                                                                                                            title="Revisar Orden"
                                                                                                        >
                                                                                                            <FontAwesomeIcon icon={faClipboardCheck} /> Revisar
                                                                                                        </button>
                                                                                                    ) : ord.revisado === 'Si' ? (
                                                                                                        <span className="badge bg-success"><FontAwesomeIcon icon={faClipboardCheck} /> Revisada</span>
                                                                                                    ) : null}

                                                                                                    <button 
                                                                                                        type="button"
                                                                                                        className="btn btn-info btn-xs text-white" 
                                                                                                        onClick={() => this.verDetalleOrdenModal(archivo, ord)} 
                                                                                                        title="Ver Detalle de Orden Interna"
                                                                                                    >
                                                                                                        <FontAwesomeIcon icon={faEye} />
                                                                                                    </button>

                                                                                                    <button 
                                                                                                        type="button"
                                                                                                        className="btn btn-success btn-xs" 
                                                                                                        onClick={() => this.descargarPDF(ord.id)} 
                                                                                                        title="Imprimir Historia Clínica"
                                                                                                    >
                                                                                                        <FontAwesomeIcon icon={faPrint} />
                                                                                                    </button>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })}
                                                                                {ordenesInternas.length === 0 && (
                                                                                    <tr><td colSpan="9" className="text-center">No hay órdenes sin facturar en este archivo.</td></tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                {archivosAMostrar && archivosAMostrar.length > 5 && this.renderBarraAccionesFacturar()}
                                {this.renderPaginacion('bottom')}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal de Validación y Edición de Órdenes a Facturar */}
                {showModalValidacionOrdenes && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1065 }} tabIndex="-1">
                        <div className="modal-dialog modal-xl modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header bg-light">
                                    <h5 className="modal-title d-flex align-items-center">
                                        <FontAwesomeIcon icon={faFileInvoice} className="me-2 text-primary" />
                                        <span>Revisión y Validación de Órdenes a Facturar ({ordenesValidacion.length})</span>
                                    </h5>
                                    <button 
                                        type="button" 
                                        className="btn-close" 
                                        onClick={this.cerrarModalValidacion} 
                                        disabled={guardandoValidacion}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    {totalErroresValidacion > 0 ? (
                                        <div className="alert alert-danger d-flex align-items-start mb-3" role="alert">
                                            <FontAwesomeIcon icon={faExclamationTriangle} className="fs-3 me-3 mt-1 flex-shrink-0" />
                                            <div>
                                                <h6 className="alert-heading fw-bold mb-1">
                                                    No puedes generar la factura porque tienes este listado de campos en vacío
                                                </h6>
                                                <p className="mb-0 small">
                                                    Hay <strong>{totalErroresValidacion}</strong> orden(es) con campos requeridos sin diligenciar (<strong>Autorización</strong> y/o <strong>Precio</strong>).
                                                    Por favor corríjalos o complételos directamente en la tabla para poder continuar con la facturación. El <strong>Copago</strong> puede ir en 0.
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="alert alert-success d-flex align-items-center mb-3" role="alert">
                                            <FontAwesomeIcon icon={faCheckCircle} className="fs-4 me-2 flex-shrink-0" />
                                            <div>
                                                <strong>¡Información completa!</strong> Todas las órdenes seleccionadas cuentan con autorización y precio válidos. Si lo desea, puede ajustar los valores antes de continuar.
                                            </div>
                                        </div>
                                    )}

                                    {/* Barra de herramientas / filtros */}
                                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3 pb-2 border-bottom">
                                        <div className="d-flex align-items-center gap-2">
                                            <button 
                                                type="button" 
                                                className={`btn btn-sm ${!filtroSoloErroresValidacion ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={() => this.setState({ filtroSoloErroresValidacion: false })}
                                            >
                                                Ver todas ({ordenesValidacion.length})
                                            </button>
                                            <button 
                                                type="button" 
                                                className={`btn btn-sm ${filtroSoloErroresValidacion ? 'btn-danger' : 'btn-outline-danger'}`}
                                                onClick={() => this.setState({ filtroSoloErroresValidacion: true })}
                                                disabled={totalErroresValidacion === 0}
                                            >
                                                Ver solo con errores ({totalErroresValidacion})
                                            </button>
                                        </div>
                                        <div>
                                            <span className="badge bg-secondary me-1">Total: {ordenesValidacion.length}</span>
                                            {totalErroresValidacion > 0 && (
                                                <span className="badge bg-danger me-1">Con errores: {totalErroresValidacion}</span>
                                            )}
                                            <span className="badge bg-success">Listas: {ordenesValidacion.length - totalErroresValidacion}</span>
                                        </div>
                                    </div>

                                    {/* Tabla de órdenes */}
                                    <div className="table-responsive" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                                        <table className="table table-bordered table-hover table-sm align-middle mb-0">
                                            <thead className="table-light sticky-top" style={{ zIndex: 1 }}>
                                                <tr>
                                                    <th className="text-center" style={{ width: '80px' }}># Orden</th>
                                                    <th>Paciente</th>
                                                    <th>Atención</th>
                                                    <th style={{ width: '220px' }}>
                                                        Autorización <span className="text-danger">*</span>
                                                    </th>
                                                    <th style={{ width: '160px' }}>
                                                        Precio ($) <span className="text-danger">*</span>
                                                    </th>
                                                    <th style={{ width: '140px' }}>
                                                        Copago ($)
                                                    </th>
                                                    <th className="text-center" style={{ width: '160px' }}>Estado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {listaOrdenesMostrar.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="7" className="text-center text-muted py-4">
                                                            No hay órdenes para mostrar con el filtro actual.
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    listaOrdenesMostrar.map((ord) => {
                                                        const faltaAutorizacion = !ord.orden_externa || !ord.orden_externa.toString().trim();
                                                        const faltaPrecio = ord.valor_atencion === '' || ord.valor_atencion === null || isNaN(parseFloat(ord.valor_atencion)) || parseFloat(ord.valor_atencion) <= 0;

                                                        return (
                                                            <tr key={ord.id} className={ord.tiene_error ? 'table-warning' : ''}>
                                                                <td className="text-center fw-bold text-dark">
                                                                    {ord.id}
                                                                </td>
                                                                <td className="text-dark">
                                                                    <div className="fw-semibold">{ord.paciente_nombre || 'Sin nombre'}</div>
                                                                    {ord.paciente_cedula && (
                                                                        <small className="text-muted d-block">Doc: {ord.paciente_cedula}</small>
                                                                    )}
                                                                </td>
                                                                <td className="text-dark">
                                                                    <div>{ord.atencion_nombre || ord.atencion || 'Sin atención'}</div>
                                                                    {ord.atencion && ord.atencion_nombre && (
                                                                        <small className="text-muted d-block">CUPS: {ord.atencion}</small>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className={`form-control form-control-sm ${faltaAutorizacion ? 'is-invalid border-danger' : 'border-success'}`}
                                                                        value={ord.orden_externa || ''}
                                                                        placeholder="Ej: AUT-12345"
                                                                        disabled={guardandoValidacion}
                                                                        onChange={(e) => this.handleValidacionCampoChange(ord.id, 'orden_externa', e.target.value)}
                                                                    />
                                                                    {faltaAutorizacion && (
                                                                        <small className="text-danger d-block mt-1 fw-bold" style={{ fontSize: '0.75rem' }}>
                                                                            Requerido
                                                                        </small>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        min="0"
                                                                        step="100"
                                                                        className={`form-control form-control-sm ${faltaPrecio ? 'is-invalid border-danger' : 'border-success'}`}
                                                                        value={ord.valor_atencion !== undefined && ord.valor_atencion !== null ? ord.valor_atencion : ''}
                                                                        placeholder="Mayor a 0"
                                                                        disabled={guardandoValidacion}
                                                                        onChange={(e) => this.handleValidacionCampoChange(ord.id, 'valor_atencion', e.target.value)}
                                                                    />
                                                                    {faltaPrecio && (
                                                                        <small className="text-danger d-block mt-1 fw-bold" style={{ fontSize: '0.75rem' }}>
                                                                            Debe ser mayor a 0
                                                                        </small>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        min="0"
                                                                        step="100"
                                                                        className="form-control form-control-sm"
                                                                        value={ord.valor_copago !== undefined && ord.valor_copago !== null ? ord.valor_copago : 0}
                                                                        placeholder="0"
                                                                        disabled={guardandoValidacion}
                                                                        onChange={(e) => this.handleValidacionCampoChange(ord.id, 'valor_copago', e.target.value)}
                                                                    />
                                                                    <small className="text-muted d-block mt-1" style={{ fontSize: '0.75rem' }}>
                                                                        Opcional (0)
                                                                    </small>
                                                                </td>
                                                                <td className="text-center">
                                                                    {ord.tiene_error ? (
                                                                        <div className="d-flex flex-column gap-1 align-items-center">
                                                                            {ord.errores.map((err, idx) => (
                                                                                <span key={idx} className="badge bg-danger" style={{ fontSize: '0.75rem' }}>
                                                                                    {err}
                                                                                </span>
                                                                            ))}
                                                                        </div>
                                                                    ) : (
                                                                        <span className="badge bg-success" style={{ fontSize: '0.75rem' }}>
                                                                            <FontAwesomeIcon icon={faCheck} className="me-1" /> Válido
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="modal-footer d-flex justify-content-between">
                                    <div className="text-muted small">
                                        {totalErroresValidacion > 0 ? (
                                            <span className="text-danger fw-bold">
                                                <FontAwesomeIcon icon={faExclamationTriangle} className="me-1" />
                                                Debe corregir {totalErroresValidacion} orden(es) para poder facturar.
                                            </span>
                                        ) : (
                                            <span className="text-success fw-bold">
                                                <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
                                                Todas las órdenes están listas para facturar.
                                            </span>
                                        )}
                                    </div>
                                    <div className="d-flex gap-2">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={this.cerrarModalValidacion}
                                            disabled={guardandoValidacion}
                                        >
                                            <FontAwesomeIcon icon={faTimes} className="me-1" /> Cancelar
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${totalErroresValidacion > 0 ? 'btn-warning' : 'btn-success'}`}
                                            onClick={this.guardarCambiosValidacion}
                                            disabled={guardandoValidacion}
                                        >
                                            {guardandoValidacion ? (
                                                <>Guardando...</>
                                            ) : totalErroresValidacion > 0 ? (
                                                <><FontAwesomeIcon icon={faSave} className="me-1" /> Guardar y Continuar a Facturar</>
                                            ) : (
                                                <><FontAwesomeIcon icon={faCheck} className="me-1" /> Continuar a Facturar</>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal de facturación */}
                {showModalFacturacion && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1070 }} tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Facturar {ordenesSeleccionadas.length} orden(es)</h5>
                                    <button type="button" className="btn-close" onClick={this.cerrarModalFacturacion} disabled={facturando}></button>
                                </div>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">EPS a facturar <span className="text-danger">*</span></label>
                                        <select className="form-control form-control-sm" value={epsFacturacion} onChange={this.handleEpsFacturacionChange} disabled={facturando}>
                                            <option value="">Seleccione una EPS</option>
                                            {empresas.map(emp => <option key={emp.id} value={emp.id}>{emp.nombre}</option>)}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Régimen a facturar <span className="text-danger">*</span></label>
                                        <select className="form-control form-control-sm" value={regimenFacturacion} onChange={(e) => this.setState({ regimenFacturacion: e.target.value })} disabled={facturando}>
                                            <option value="">Seleccione un régimen</option>
                                            {regimenes.map(reg => <option key={reg.id} value={reg.codigo}>{reg.nombre}</option>)}
                                        </select>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label">Modalidad de Pago <span className="text-danger">*</span></label>
                                            <select className="form-control form-control-sm" value={modalidadFacturacion} onChange={(e) => this.setState({ modalidadFacturacion: e.target.value })} disabled={facturando}>
                                                <option value="">Seleccione</option>
                                                {modalidades.map(mod => <option key={mod.id} value={mod.id || mod.codigo}>{mod.nombre}</option>)}
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Plan de Servicio <span className="text-danger">*</span></label>
                                            <select className="form-control form-control-sm" value={planFacturacion} onChange={(e) => this.setState({ planFacturacion: e.target.value })} disabled={facturando}>
                                                <option value="">Seleccione</option>
                                                {planes.map(pl => <option key={pl.id} value={pl.id || pl.codigo}>{pl.nombre}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-success" onClick={this.facturarSeleccionadas} disabled={facturando || (epsSeleccionada && epsFacturacion !== epsSeleccionada)}>
                                        {facturando ? "Facturando..." : <><FontAwesomeIcon icon={faFileInvoice} /> Confirmar Facturación</>}
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={this.cerrarModalFacturacion} disabled={facturando}>Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal de ver orden (archivo completo) */}
                {showModalOrden && ordenSeleccionada && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }} tabIndex="-1">
                        <div className="modal-dialog modal-fullscreen modal-dialog-scrollable">
                            <div className="modal-content" style={{ minHeight: '90vh' }}>
                                <div className="modal-header bg-light">
                                    <h5 className="modal-title">
                                        Detalle de Archivo #{ordenSeleccionada.numero_archivo || ordenSeleccionada.id} - {ordenSeleccionada.nombre} {ordenSeleccionada.apellido}
                                    </h5>
                                    <button type="button" className="btn-close" onClick={this.cerrarModalOrden}></button>
                                </div>
                                <div className="modal-body p-0">
                                    <Ordenes />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal de ver detalle de orden interna */}
                {showModalDetalleOrden && ordenDetalleSeleccionada && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }} tabIndex="-1">
                        <div className="modal-dialog modal-xl modal-dialog-scrollable">
                            <div className="modal-content" style={{ minHeight: '85vh' }}>
                                <div className="modal-header bg-light">
                                    <h5 className="modal-title">
                                        Detalle de Orden Interna #{ordenDetalleSeleccionada.id} - {ordenDetalleSeleccionada.atencion_nombre || ordenDetalleSeleccionada.atencion || ''} {ordenDetalleSeleccionada.archivo_obj ? `(${ordenDetalleSeleccionada.archivo_obj.nombre} ${ordenDetalleSeleccionada.archivo_obj.apellido})` : ''}
                                    </h5>
                                    <button type="button" className="btn-close" onClick={this.cerrarModalDetalleOrden}></button>
                                </div>
                                <div className="modal-body p-0">
                                    <OrdenesDetalle />
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={this.cerrarModalDetalleOrden}>
                                        <FontAwesomeIcon icon={faClose} /> Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default FacturarArchivo;